import React from 'react';
import { Tooltip } from 'shared/components/atoms/Tooltip';

export const QuoteNotOrderableTooltip = () => (
  <Tooltip multiline text="This quote cannot be ordered">
    <h6>This quote cannot be ordered</h6>
    Please make sure you have selected all required options to proceed.
  </Tooltip>
);
